import { UserCreateRequest, User, UserUpdateRequest, UserLogin } from '../types';

import axiosInstance from './axiosInstance';

export async function createUser(req: UserCreateRequest) {
  const response = await axiosInstance.post(`/users`, req);
  return response.data as UserLogin;
}

export async function updateUser(req: UserUpdateRequest) {
  const response = await axiosInstance.put(`/users/${req.userUuid}`, req);
  return response.data as UserLogin;
}
